import { ACTIVE_CLIENT_ID } from './active';
import { resolveClient } from './registry';
import type { ClientFeatures, ClientTheme } from './types';

export type {
  CategoryId,
  ClientConfig,
  ClientFeatures,
  ClientGame,
  ClientHome,
  ClientTheme,
} from './types';
export { CLIENTS, DEFAULT_CLIENT_ID, resolveClient } from './registry';
export type { ClientId } from './registry';

export { ACTIVE_CLIENT_ID } from './active';

/**
 * The client this build is running as, taken from `src/clients/active.ts`.
 *
 * Resolved once at module load: the value can't change while the app is
 * running, so everything downstream can treat it as a constant.
 */
export const CLIENT = resolveClient(ACTIVE_CLIENT_ID);

/**
 * Writes the client palette onto `:root` as `--color-*` custom properties.
 *
 * Tailwind's colour tokens read those variables, so this is what makes
 * `bg-brand` / `text-app` resolve to the active client. Call it before the
 * first render — `main.tsx` does — so nothing paints with stale colours.
 */
export function applyClientTheme(theme: ClientTheme = CLIENT.theme): void {
  const root = document.documentElement;
  for (const [token, value] of Object.entries(theme)) {
    root.style.setProperty(`--color-${token}`, value);
  }
}

/**
 * Whether a capability is enabled for the active client.
 *
 * Prefer this over comparing client ids: a new client should be a config
 * change, not a new branch in the code.
 */
export function isFeature(name: keyof ClientFeatures): boolean {
  return CLIENT.features[name];
}
